module.exports = __webpack_public_path__ + "img/icomoon.3942c34.svg";